/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const CreateOrgUser = /* GraphQL */ `
  mutation CreateOrgUser($input: CreateOrgUserInput) {
    CreateOrgUser(input: $input)
  }
`;
export const UpdateOrgUser = /* GraphQL */ `
  mutation UpdateOrgUser($input: UpdateOrgUserInput) {
    UpdateOrgUser(input: $input)
  }
`;
export const DeleteOrgUser = /* GraphQL */ `
  mutation DeleteOrgUser($input: DeleteOrgUserInput) {
    DeleteOrgUser(input: $input)
  }
`;
export const ResetOrgUserPassword = /* GraphQL */ `
  mutation ResetOrgUserPassword($input: ResetOrgUserPasswordInput) {
    ResetOrgUserPassword(input: $input)
  }
`;
export const updateOrgProfile = /* GraphQL */ `
  mutation UpdateOrgProfile($input: UpdateOrgProfileInput) {
    updateOrgProfile(input: $input)
  }
`;
export const formatGreetingMessage = /* GraphQL */ `
  mutation FormatGreetingMessage($input: formatGreetingMessageInput) {
    formatGreetingMessage(input: $input)
  }
`;
export const formatSystemPrompt = /* GraphQL */ `
  mutation FormatSystemPrompt($input: formatSystemPromptInput) {
    formatSystemPrompt(input: $input)
  }
`;
export const initiateOutgoingCall = /* GraphQL */ `
  mutation InitiateOutgoingCall($input: initiateOutgoingCallInput) {
    initiateOutgoingCall(input: $input)
  }
`;
export const generatePresignedUrlForPut = /* GraphQL */ `
  mutation GeneratePresignedUrlForPut($input: generatePresignedUrlForPutInput) {
    generatePresignedUrlForPut(input: $input)
  }
`;
export const generateGetPresignedUrl = /* GraphQL */ `
  mutation GenerateGetPresignedUrl($input: generateGetPresignedUrlInput) {
    generateGetPresignedUrl(input: $input)
  }
`;
export const requestCredits = /* GraphQL */ `
  mutation RequestCredits($input: requestCreditsInput) {
    requestCredits(input: $input)
  }
`;
export const addUniqueCaller = /* GraphQL */ `
  mutation AddUniqueCaller($input: addUniqueCallerInput) {
    addUniqueCaller(input: $input)
  }
`;
export const bulkAddCallers = /* GraphQL */ `
  mutation BulkAddCallers($input: bulkAddCallersInput) {
    bulkAddCallers(input: $input)
  }
`;
export const removeOrgCaller = /* GraphQL */ `
  mutation RemoveOrgCaller($input: removeOrgCallerInput) {
    removeOrgCaller(input: $input)
  }
`;
export const editOrgCaller = /* GraphQL */ `
  mutation EditOrgCaller($input: removeOrgCallerInput) {
    editOrgCaller(input: $input)
  }
`;
export const addOrRemoveCallerFromBlockList = /* GraphQL */ `
  mutation AddOrRemoveCallerFromBlockList(
    $input: addOrRemoveCallerFromBlockListInput
  ) {
    addOrRemoveCallerFromBlockList(input: $input)
  }
`;
export const initiateTestCall = /* GraphQL */ `
  mutation InitiateTestCall($input: initiateTestCallInput) {
    initiateTestCall(input: $input)
  }
`;
export const generateOrgApiKey = /* GraphQL */ `
  mutation GenerateOrgApiKey($input: generateOrgApiKeyInput) {
    generateOrgApiKey(input: $input)
  }
`;
export const generateOrgOAuthClient = /* GraphQL */ `
  mutation GenerateOrgOAuthClient($input: generateOrgOAuthClientInput) {
    generateOrgOAuthClient(input: $input)
  }
`;
export const convertTextToSpeech = /* GraphQL */ `
  mutation ConvertTextToSpeech($input: convertTextToSpeechInput) {
    convertTextToSpeech(input: $input)
  }
`;
export const createRazorpayOrder = /* GraphQL */ `
  mutation CreateRazorpayOrder($input: createRazorpayOrderInput) {
    createRazorpayOrder(input: $input)
  }
`;
export const createOnCallAction = /* GraphQL */ `
  mutation CreateOnCallAction($input: createOnCallActionInput) {
    createOnCallAction(input: $input)
  }
`;
export const updateOnCallAction = /* GraphQL */ `
  mutation UpdateOnCallAction($input: updateOnCallActionInput) {
    updateOnCallAction(input: $input)
  }
`;
export const configureTemplateAction = /* GraphQL */ `
  mutation ConfigureTemplateAction($input: configureTemplateActionInput) {
    configureTemplateAction(input: $input)
  }
`;
export const deleteOnCallAction = /* GraphQL */ `
  mutation DeleteOnCallAction($input: deleteOnCallActionInput) {
    deleteOnCallAction(input: $input)
  }
`;
export const enableOnCallAction = /* GraphQL */ `
  mutation EnableOnCallAction($input: enableDisableOnCallActionInput) {
    enableOnCallAction(input: $input)
  }
`;
export const disableOnCallAction = /* GraphQL */ `
  mutation DisableOnCallAction($input: enableDisableOnCallActionInput) {
    disableOnCallAction(input: $input)
  }
`;
export const createContext = /* GraphQL */ `
  mutation CreateContext($input: createContextInput) {
    createContext(input: $input)
  }
`;
export const updateContext = /* GraphQL */ `
  mutation UpdateContext($input: updateContextInput) {
    updateContext(input: $input)
  }
`;
export const disableContext = /* GraphQL */ `
  mutation DisableContext($input: disableContextInput) {
    disableContext(input: $input)
  }
`;
export const enableContext = /* GraphQL */ `
  mutation EnableContext($input: enableContextInput) {
    enableContext(input: $input)
  }
`;
export const deleteContext = /* GraphQL */ `
  mutation DeleteContext($input: deleteContextInput) {
    deleteContext(input: $input)
  }
`;
export const addContextFields = /* GraphQL */ `
  mutation AddContextFields($input: addContextFieldsInput) {
    addContextFields(input: $input)
  }
`;
export const removeContextFields = /* GraphQL */ `
  mutation RemoveContextFields($input: removeContextFieldsInput) {
    removeContextFields(input: $input)
  }
`;
export const updateContextReportColumns = /* GraphQL */ `
  mutation UpdateContextReportColumns($input: updateContextReportColumnsInput) {
    updateContextReportColumns(input: $input)
  }
`;
export const addOrgDefaultFields = /* GraphQL */ `
  mutation AddOrgDefaultFields($input: addOrgDefaultFieldsInput) {
    addOrgDefaultFields(input: $input)
  }
`;
export const removeOrgDefaultFields = /* GraphQL */ `
  mutation RemoveOrgDefaultFields($input: removeOrgDefaultFieldsInput) {
    removeOrgDefaultFields(input: $input)
  }
`;
export const addOrgDefaultLeadStatuses = /* GraphQL */ `
  mutation AddOrgDefaultLeadStatuses($input: addOrgDefaultLeadStatusesInput) {
    addOrgDefaultLeadStatuses(input: $input)
  }
`;
export const removeOrgDefaultLeadStatuses = /* GraphQL */ `
  mutation RemoveOrgDefaultLeadStatuses(
    $input: removeOrgDefaultLeadStatusesInput
  ) {
    removeOrgDefaultLeadStatuses(input: $input)
  }
`;
export const recordContextFile = /* GraphQL */ `
  mutation RecordContextFile($input: recordContextFileInput) {
    recordContextFile(input: $input)
  }
`;
export const removeContextFile = /* GraphQL */ `
  mutation RemoveContextFile($input: removeContextFileInput) {
    removeContextFile(input: $input)
  }
`;
export const editContextFile = /* GraphQL */ `
  mutation EditContextFile($input: editContextFileInput) {
    editContextFile(input: $input)
  }
`;
export const createLead = /* GraphQL */ `
  mutation CreateLead($input: createLeadInput) {
    createLead(input: $input)
  }
`;
export const getBulkLeadUploadUrl = /* GraphQL */ `
  mutation GetBulkLeadUploadUrl($input: getBulkLeadUploadUrlInput) {
    getBulkLeadUploadUrl(input: $input)
  }
`;
export const editLead = /* GraphQL */ `
  mutation EditLead($input: editLeadInput) {
    editLead(input: $input)
  }
`;
export const deleteLead = /* GraphQL */ `
  mutation DeleteLead($input: deleteLeadInput) {
    deleteLead(input: $input)
  }
`;
export const disableLead = /* GraphQL */ `
  mutation DisableLead($input: disableLeadInput) {
    disableLead(input: $input)
  }
`;
export const enableLead = /* GraphQL */ `
  mutation EnableLead($input: enableLeadInput) {
    enableLead(input: $input)
  }
`;
export const updateLeadStatus = /* GraphQL */ `
  mutation UpdateLeadStatus($input: updateLeadStatusInput) {
    updateLeadStatus(input: $input)
  }
`;
export const deleteBulkUploadLeads = /* GraphQL */ `
  mutation DeleteBulkUploadLeads($input: deleteBulkUploadLeadsInput) {
    deleteBulkUploadLeads(input: $input)
  }
`;
export const bulkDeleteLeads = /* GraphQL */ `
  mutation BulkDeleteLeads($input: bulkDeleteLeadsInput) {
    bulkDeleteLeads(input: $input)
  }
`;
export const bulkUpdateLeadStatus = /* GraphQL */ `
  mutation BulkUpdateLeadStatus($input: bulkUpdateLeadStatusInput) {
    bulkUpdateLeadStatus(input: $input)
  }
`;
export const addContextLeadStatuses = /* GraphQL */ `
  mutation AddContextLeadStatuses($input: addContextLeadStatusesInput) {
    addContextLeadStatuses(input: $input)
  }
`;
export const removeContextLeadStatuses = /* GraphQL */ `
  mutation RemoveContextLeadStatuses($input: removeContextLeadStatusesInput) {
    removeContextLeadStatuses(input: $input)
  }
`;
export const setAgentSoftphoneExtension = /* GraphQL */ `
  mutation SetAgentSoftphoneExtension($input: setAgentSoftphoneExtensionInput) {
    setAgentSoftphoneExtension(input: $input)
  }
`;
export const initiateSoftphoneCall = /* GraphQL */ `
  mutation InitiateSoftphoneCall($input: initiateSoftphoneCallInput) {
    initiateSoftphoneCall(input: $input)
  }
`;
export const initiateNextSoftphoneAutoDialCall = /* GraphQL */ `
  mutation InitiateNextSoftphoneAutoDialCall(
    $input: initiateNextSoftphoneAutoDialCallInput
  ) {
    initiateNextSoftphoneAutoDialCall(input: $input)
  }
`;
export const createTask = /* GraphQL */ `
  mutation CreateTask($input: createTaskInput) {
    createTask(input: $input)
  }
`;
export const createTeamMember = /* GraphQL */ `
  mutation CreateTeamMember($input: createTeamMemberInput) {
    createTeamMember(input: $input)
  }
`;
export const bulkCreateTeamMembers = /* GraphQL */ `
  mutation BulkCreateTeamMembers($input: bulkCreateTeamMembersInput) {
    bulkCreateTeamMembers(input: $input)
  }
`;
export const editTeamMember = /* GraphQL */ `
  mutation EditTeamMember($input: editTeamMemberInput) {
    editTeamMember(input: $input)
  }
`;
export const deleteTeamMember = /* GraphQL */ `
  mutation DeleteTeamMember($input: deleteTeamMemberInput) {
    deleteTeamMember(input: $input)
  }
`;
export const deleteTask = /* GraphQL */ `
  mutation DeleteTask($input: deleteTaskInput) {
    deleteTask(input: $input)
  }
`;
export const createSlotResource = /* GraphQL */ `
  mutation CreateSlotResource($input: CreateSlotResourceInput) {
    createSlotResource(input: $input)
  }
`;
export const updateSlotResource = /* GraphQL */ `
  mutation UpdateSlotResource($input: UpdateSlotResourceInput) {
    updateSlotResource(input: $input)
  }
`;
export const deleteSlotResource = /* GraphQL */ `
  mutation DeleteSlotResource($input: DeleteSlotResourceInput) {
    deleteSlotResource(input: $input)
  }
`;
export const cancelSlotBooking = /* GraphQL */ `
  mutation CancelSlotBooking($input: CancelSlotBookingInput) {
    cancelSlotBooking(input: $input)
  }
`;
export const editTask = /* GraphQL */ `
  mutation EditTask($input: editTaskInput) {
    editTask(input: $input)
  }
`;
export const triggerDashboardDigestNow = /* GraphQL */ `
  mutation TriggerDashboardDigestNow($input: triggerDashboardDigestNowInput) {
    triggerDashboardDigestNow(input: $input)
  }
`;
export const updateTaskReportDigestConfig = /* GraphQL */ `
  mutation UpdateTaskReportDigestConfig($input: updateTaskReportDigestConfigInput) {
    updateTaskReportDigestConfig(input: $input)
  }
`;
export const triggerReportDigestNow = /* GraphQL */ `
  mutation TriggerReportDigestNow($input: triggerReportDigestNowInput) {
    triggerReportDigestNow(input: $input)
  }
`;
export const getTaskVoiceAudioUploadUrl = /* GraphQL */ `
  mutation GetTaskVoiceAudioUploadUrl($input: getTaskVoiceAudioUploadUrlInput) {
    getTaskVoiceAudioUploadUrl(input: $input)
  }
`;
export const getTaskVoiceAudioPreviewUrl = /* GraphQL */ `
  mutation GetTaskVoiceAudioPreviewUrl($input: getTaskVoiceAudioPreviewUrlInput) {
    getTaskVoiceAudioPreviewUrl(input: $input)
  }
`;
export const assignLeadToAgent = /* GraphQL */ `
  mutation AssignLeadToAgent($input: assignLeadToAgentInput) {
    assignLeadToAgent(input: $input)
  }
`;
export const bulkAssignLeadsToAgents = /* GraphQL */ `
  mutation BulkAssignLeadsToAgents($input: bulkAssignLeadsToAgentsInput) {
    bulkAssignLeadsToAgents(input: $input)
  }
`;
export const runTaskAICalls = /* GraphQL */ `
  mutation RunTaskAICalls($input: runTaskAICallsInput) {
    runTaskAICalls(input: $input)
  }
`;
export const updateMyTaskLeadStatus = /* GraphQL */ `
  mutation UpdateMyTaskLeadStatus($input: updateMyTaskLeadStatusInput) {
    updateMyTaskLeadStatus(input: $input)
  }
`;
export const bulkUpdateTaskLeadStatus = /* GraphQL */ `
  mutation BulkUpdateTaskLeadStatus($input: bulkUpdateTaskLeadStatusInput) {
    bulkUpdateTaskLeadStatus(input: $input)
  }
`;
export const bulkUpdateAllTaskLeadStatus = /* GraphQL */ `
  mutation BulkUpdateAllTaskLeadStatus(
    $input: bulkUpdateAllTaskLeadStatusInput
  ) {
    bulkUpdateAllTaskLeadStatus(input: $input)
  }
`;
export const generateLeadComments = /* GraphQL */ `
  mutation GenerateLeadComments($input: generateLeadCommentsInput) {
    generateLeadComments(input: $input)
  }
`;
export const reportPlatformIssue = /* GraphQL */ `
  mutation ReportPlatformIssue($input: reportPlatformIssueInput) {
    reportPlatformIssue(input: $input)
  }
`;
export const recordAICallActivity = /* GraphQL */ `
  mutation RecordAICallActivity($input: recordAICallActivityInput) {
    recordAICallActivity(input: $input)
  }
`;
export const submitCallFeedback = /* GraphQL */ `
  mutation SubmitCallFeedback($input: submitCallFeedbackInput) {
    submitCallFeedback(input: $input)
  }
`;

/* Runs a documented endpoint against the live public API. The portal performs
   the call server-side because authenticating needs the organisation's OAuth
   secret, which must never reach a browser. */
export const runPublicApiTest = /* GraphQL */ `
  mutation RunPublicApiTest($input: runPublicApiTestInput) {
    runPublicApiTest(input: $input)
  }
`
